var map = {
	"./bash": 1655,
	"./java": 1656,
	"./json": 1657,
	"./julia": 1658,
	"./python": 1659,
	"./r": 1660,
	"./rust": 1661,
	"./scala": 1662,
	"./shell": 1663,
	"./sql": 1664,
	"./xml": 1665,
	"./yaml": 1666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1654;